const baseUrl = process.env.REACT_APP_BASE_URL;
export const CHECKTOKEN_API = baseUrl + "/api/auth";

export const LOGIN_API = baseUrl + "/api/auth/login"; //POST
export const REGISTER_API = baseUrl + "/api/auth/register"; //POST

export const PRICE_API = baseUrl + "/api/price"; //GET POST
export const BOOKING_API = baseUrl + "/api/booking"; //GET POST
export const BOOKINGS_API = baseUrl + "/api/booking/all"; //GET
